import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/petition-settings/{creatorId}';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

/** Updates creator petition settings. */
const updatePetitionSettings = async ({ creatorId, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.put(path, body);
  return response.data as Output;
};

export default updatePetitionSettings;
